export const copyMotion = {
    initial: {
        opacity: 0,
        y: 10
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .5,
            delay: 0
        }
    },
    exit: {
        opacity: 0,
        x: -20,
        transition: {
            duration: .5
        }
    }
}

export const textMotion = {
    initial: {
        opacity: 0,
        y: 10,
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .5,
            delay: .5
        }
    },
    exit: {
        opacity: 0,
        x: -20,
        transition: {
            duration: .5
        }
    }
}

export const buttonMotion = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition: {
            duration: .5,
            delay: .7
        }
    },
    exit: {
        opacity: 0,
        x: -20,
        transition: {
            duration: .5
        }
    }
}

export const imgMotion = {
    initial: {
        opacity: 0,
        y: 10,
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .5,
            delay: .5
        }
    },
    exit: {
        opacity: 0,
        x: -20,
        transition: {
            duration: .5
        }
    }
}